import type ConfirmationModal from './ConfirmationModal';

class ConfirmationModalHandle {
  constructor(private modal: ConfirmationModal) {
  }

  scrollToTop() {
    this.modal.scrollToTop();
  }

  close() {
    this.modal.close();
  }

  getButtonConfirm() {
    return this.modal.$btnConfirm[0] as HTMLButtonElement;
  }

  getButtonCancel() {
    return this.modal.$btnCancel[0] as HTMLButtonElement;
  }
}

export default ConfirmationModalHandle;
